module.exports = __webpack_public_path__ + "files/8cdbe56a7ca19e3964de9cbd4383d2c3.png";